import { memo, useState } from 'react'

import { Text } from '@cash-me/react-components'
import NextImage from 'next/image'

import { Play } from 'components/video-player/Play'

import { SocialMediaVideo } from '../social-media.model'

import * as S from './styles'

// Shared with the warm-up in the section above: the srcset candidate the browser
// picks depends only on this string, so both must use it to request the same URL.
export const THUMB_SIZES = '(max-width: 767px) 80vw, 18rem'

type Props = SocialMediaVideo & {
  label: string
  onPlay?: () => void
}

export const SocialCard = memo(({ type, label, videoUrl, videoTitle, thumbnail, alt, onPlay }: Props) => {
  const [isVideoVisible, setIsVideoVisible] = useState(false)

  const handlePlay = () => {
    setIsVideoVisible(true)
    if (onPlay) onPlay()
  }

  if (isVideoVisible) {
    return (
      <S.Card>
        <S.VideoWrapper>
          {type === 'video' ? (
            // eslint-disable-next-line jsx-a11y/media-has-caption
            <video src={videoUrl} title={videoTitle} controls autoPlay playsInline />
          ) : (
            <iframe
              src={videoUrl}
              title={videoTitle}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </S.VideoWrapper>
      </S.Card>
    )
  }

  return (
    <S.Card>
      {thumbnail ? (
        <NextImage src={thumbnail} alt={alt} fill sizes={THUMB_SIZES} style={{ objectFit: 'contain' }} />
      ) : (
        <S.Placeholder aria-hidden>
          <Text size="body2" weight="medium" color="var(--colors-neutral-text-contrast-default)">
            {label}
          </Text>
        </S.Placeholder>
      )}

      {videoUrl && (
        <S.PlayButton type="button" onClick={handlePlay} aria-label={`Reproduzir vídeo do ${label}`}>
          <Play />
        </S.PlayButton>
      )}
    </S.Card>
  )
})

SocialCard.displayName = 'SocialCard'
